import { PropsWithChildren } from 'react'

import { Badge, Space } from 'antd'
import { createStyles } from 'antd-style'

import { RouterLink } from '@eastcoal/router/components/Link'

import { ListTitleLinkProps } from './interface'

const useStyles = createStyles(
  ({ token }, { maxWidth }: { maxWidth: string | number }) => ({
    text: {
      maxWidth,
      display: 'inline-block',
      verticalAlign: 'bottom',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    }
  })
)

export const ListTitleLink = ({
  to,
  maxWidth = 520,
  dot = true,
  addonBefore,
  children
}: PropsWithChildren<ListTitleLinkProps>) => {
  const { theme, styles } = useStyles({ maxWidth })

  const textNode = (
    <RouterLink newtab className={styles.text} to={to} type='text'>
      {children}
    </RouterLink>
  )

  const contentNode = addonBefore ? (
    <Space size={4} wrap={false}>
      {addonBefore}
      {textNode}
    </Space>
  ) : (
    textNode
  )

  return dot ? (
    <Badge
      color={typeof dot === 'object' ? dot.color : theme.blue2}
      dot={false}
      text={contentNode}
      styles={{
        indicator: {
          width: 4,
          height: 4
        }
      }}
    />
  ) : (
    contentNode
  )
}
